export const titleTemplate: string = '%s - Country Allocation'
